// Czyste reguły rejestru urzędów — wykrywanie duplikatów i wyszukiwarka.
//
// Osobny moduł, nie funkcje w OfficesPage: pomocniki testują się bez renderowania strony,
// a plik strony zostaje przy samych komponentach (inaczej Fast Refresh przeładowuje ją
// w całości przy każdej edycji).
import type { Office } from "@/features/power_projects/types";

/** Klucz tożsamości wpisu: nazwa i wydział bez ogonków, wielkości liter i podwójnych spacji.
 *  „Urząd Gminy Bytów" i „URZAD GMINY  BYTOW" to ten sam urząd wpisany dwa razy — takich par
 *  rejestr dorobił się, dopóki jedynym sposobem na poprawkę było założenie nowego wpisu.
 *  Wydział zostaje w kluczu: ten sam urząd z innym wydziałem to osobny adresat, nie duplikat. */
export const dupKey = (o: Office) =>
  `${o.name}|${o.department ?? ""}`
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/ł/gi, "l")
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim();

/** Nazwy występujące w rejestrze więcej niż raz — kandydaci do scalenia. */
export const duplicateKeys = (offices: Office[]) => {
  const seen = new Map<string, number>();
  for (const o of offices) {
    const k = dupKey(o);
    seen.set(k, (seen.get(k) ?? 0) + 1);
  }
  return new Set([...seen].filter(([, n]) => n > 1).map(([k]) => k));
};

/** Wyszukiwarka rejestru — te same pola, po których filtruje backend (?search=),
 *  plus wydział, bo to on rozróżnia wpisy o tej samej nazwie. `q` małymi literami. */
export const officeMatches = (o: Office, q: string) =>
  [o.name, o.department, o.contact_person, o.street, o.city, o.postal_code]
    .filter(Boolean)
    .some((v) => v!.toLowerCase().includes(q));
